import { useState } from 'react';

const faqs = [
  { q: 'What is the AllChinaBuy Spreadsheet?', a: 'The AllChinaBuy Spreadsheet is an organized resource that compiles product information, seller details, and buying guides to help you research products more efficiently.' },
  { q: 'How does the AllChinaBuy Spreadsheet work?', a: 'The spreadsheet categorizes products by type, allowing you to browse categories, compare options, and find relevant sellers with detailed information.' },
  { q: 'Is AllChinaBuy legit?', a: 'AllChinaBuy is a buying agent platform. Like any international marketplace, it is important to research sellers, review QC photos, and understand the process before purchasing.' },
  { q: 'Is AllChinaBuy safe?', a: 'Safety depends on following best practices: verify sellers, review QC photos, use secure payment methods, and understand shipping and refund policies.' },
  { q: 'How much does AllChinaBuy shipping cost?', a: 'Shipping costs vary based on parcel weight, dimensions, destination, shipping method, and current carrier rates. Use our shipping guide for detailed information.' },
  { q: 'Where is the AllChinaBuy warehouse?', a: 'AllChinaBuy operates warehouses in China for receiving, inspecting, and forwarding parcels to international buyers.' },
  { q: 'How do AllChinaBuy coupons work?', a: 'Coupons and discount codes may be available for new users, seasonal promotions, or specific product categories. Always verify terms and expiration dates.' },
  { q: 'Where can I find an AllChinaBuy discount code?', a: 'Discount codes may be available through promotional emails, affiliate partners, or seasonal campaigns. Check our coupon guide for current information.' },
  { q: 'How do I check QC photos?', a: 'QC photos are taken at the warehouse before shipping. You can review them in your account to verify product condition, color, and details.' },
  { q: 'How can I find products through AllChinaBuy?', a: 'Use the spreadsheet to browse categories, or search directly by product name, category, or seller to find what you are looking for.' },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-20 bg-background-50" id="faq">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-sm font-semibold text-primary-600 tracking-wider uppercase">FAQ</span>
          <h2 className="mt-3 text-2xl md:text-3xl font-bold text-foreground-950">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-white rounded-lg border border-background-200 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-background-50 transition-colors"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.q}
                </span>
                <i
                  className={`ri-add-line text-lg text-primary-500 transition-transform flex-shrink-0 ${
                    openIndex === idx ? 'rotate-45' : ''
                  }`}
                />
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed border-t border-background-100 pt-3">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* FAQ Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqs.map((f) => ({
              "@type": "Question",
              "name": f.q,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": f.a
              }
            }))
          })}
        </script>
      </div>
    </section>
  );
}